/**

    * Application Name: Zevcore unolo Backend
    * Application Version: 1.0
    * Author: Zevcore Private Limited
    * Created Date: 17.05.2023
    * Last Modified Date: 17.05.2023
    * Developer Name: Anand_Krishna

**/

import React from "react";
import { useNavigate } from "react-router-dom"; // for import react dom navigation components
import { Text, Card, Paper } from "@mantine/core"; // for import mantine required functions and theme
import { Home } from "tabler-icons-react"; // for icons

const ManagerBreadCrumb = (props) => {
  // navigation import for navigate to page
  let navigate = useNavigate();
  const handleClick = (event) => {
    navigate(event);
  };

  return (
    <Paper
      style={{
        display: "flex",
        backgroundColor: "transparent",
        justifyContent: "space-between",
        marginRight: 5,
        marginLeft: 5,
        marginBottom: 0,
      }}
    >
      {/* Props text name Main page name */}
      <Text>
        {props.Text} {props.Name ? <span>( {props.Name} )</span> : null}
      </Text>

      {/* Show right side bread crumb with link */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            cursor: "pointer",
          }}
          onClick={() => handleClick("/manager/Dashboard")}
        >
          <Home style={{ paddingTop: 0 }} size={12} />
        </p>
        {/* For title page */}
        {props.Title ? (
          <>
            <p style={{ paddingTop: 0 }}> &nbsp; / &nbsp;</p>
            <p
              style={{
                cursor: "pointer",
                fontSize: 12,
                paddingTop: 4,
              }}
              onClick={() => handleClick(props.titleLink)}
            >
              {" "}
              {props.Title}
            </p>
          </>
        ) : null}
        {/* For text page */}
        {props.Text ? (
          <>
            <p style={{ paddingTop: 0 }}> &nbsp; / &nbsp;</p>
            <p
              style={{
                cursor: "pointer",
                fontSize: 12,
                paddingTop: 4,
              }}
              className="zc-breadcrumb-text"
            >
              {" "}
              {props.Text}
            </p>
          </>
        ) : null}
      </div>
    </Paper>
  );
};

export default ManagerBreadCrumb;
